import React from 'react';
import { theme } from '../../styles/theme';

interface FilterChipsProps {
  title: string;
  items: string[];
  selectedItems: string[];
  onToggle: (item: string) => void;
}

const FilterChips: React.FC<FilterChipsProps> = ({ title, items, selectedItems, onToggle }) => {
  const containerStyle: React.CSSProperties = {
    marginBottom: theme.spacing.xl,
  };

  const labelStyle: React.CSSProperties = {
    display: 'block',
    marginBottom: theme.spacing.sm,
    fontSize: '0.875rem',
    fontWeight: '600',
    color: theme.colors.text,
  };

  const chipsContainerStyle: React.CSSProperties = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing.sm,
    maxHeight: '200px',
    overflowY: 'auto',
    padding: theme.spacing.sm,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: theme.borderRadius.md,
  };

  const chipStyle: React.CSSProperties = {
    padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
    borderRadius: theme.borderRadius.md,
    fontSize: '0.875rem',
    fontWeight: '500',
    cursor: 'pointer',
    transition: `all ${theme.transitions.fast}`,
    border: 'none',
    outline: 'none',
  };

  const availableChipStyle: React.CSSProperties = {
    ...chipStyle,
    backgroundColor: theme.colors.surfaceLight,
    color: theme.colors.text,
    border: `1px solid ${theme.colors.border}`,
  };

  // const selectedChipStyle: React.CSSProperties = {
  //   ...chipStyle,
  //   backgroundColor: theme.colors.primary,
  //   color: 'white',
  // };

  const availableItems = items.filter(item => !selectedItems.includes(item));

  return (
    <div style={containerStyle}>
      <label style={labelStyle}>{title}</label>
      <div style={chipsContainerStyle} className="scrollbar-thin">
        {availableItems.map((item) => (
          <button
            key={item}
            style={availableChipStyle}
            onClick={() => onToggle(item)}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = theme.colors.primary;
              e.currentTarget.style.color = 'white';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = theme.colors.surfaceLight;
              e.currentTarget.style.color = theme.colors.text;
            }}
          >
            {item}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FilterChips;